import { Component, type ErrorInfo, type ReactNode } from 'react'

import { newFailureId, report } from './diagnostics'
import { StatusScreen } from './StatusScreen'
import { t } from './i18n'

/**
 * A throw outside the whiteboard used to blank the whole classroom.
 * Reload is safe here: the reconnect credential lives in localStorage.
 */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failureId: string | null }> {
  state: { failureId: string | null } = { failureId: null }

  static getDerivedStateFromError(): { failureId: string } {
    return { failureId: newFailureId() }
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    report({}, {
      stage: 'join_failed',
      outcome: 'error',
      errorKind: error.name || 'render',
      failureId: this.state.failureId ?? undefined,
    })
  }

  render(): ReactNode {
    if (!this.state.failureId) return this.props.children
    return (
      <StatusScreen title={t('error.unknown.title')} detail={t('error.unknown.detail')}>
        <button className="primary-button" onClick={() => window.location.reload()}>
          {t('error.retry')}
        </button>
        <p className="failure-reference">
          {t('error.reference')}: <code>{this.state.failureId}</code>
        </p>
      </StatusScreen>
    )
  }
}
